import { TMBoardId, TimeMaterialBoardResponse } from '@business/entities/tm/TimeMaterialBoardResponse';
import { Endpoint } from '../endpoint';
import { R } from '@core/utils/r';
import { TimeMaterialsFilterData } from '@modules/timeMaterials/TimeMaterialsPage/TimeMaterialsPage';

export function fetchTimeMaterialBoards(permission = true, isCompact = false) {
  return Endpoint.get<TimeMaterialBoardResponse[]>(`@gc/tm-board`, { params: { permission, isCompact } });
}

export function fetchTimeMaterialBoard(id: TMBoardId, data?: Partial<TimeMaterialsFilterData>, isVeryCompact?: boolean) {
  const params = R.objectCompact({ ...data, isVeryCompact });

  return Endpoint.get<TimeMaterialBoardResponse>(`@gc/tm-board/board/${id || '9999'}`, { params });
}

export function createTimeMaterialBoard(data: Partial<TimeMaterialBoardResponse>) {
  return Endpoint.post<TimeMaterialBoardResponse>(`@gc/tm-board`, { data });
}

export function updateTimeMaterialBoard(id: string, data: Partial<TimeMaterialBoardResponse>) {
  return Endpoint.patch<TimeMaterialBoardResponse>(`@gc/tm-board/${id}`, { data });
}

export function deleteTimeMaterialBoard(id: string) {
  return Endpoint.delete<void>(`@gc/tm-board/${id}`);
}
